import { render, staticRenderFns } from "./KirmiziSantralWebhooks.vue?vue&type=template&id=449ea19e&scoped=true"
import script from "./KirmiziSantralWebhooks.vue?vue&type=script&lang=js"
export * from "./KirmiziSantralWebhooks.vue?vue&type=script&lang=js"
import style0 from "./KirmiziSantralWebhooks.vue?vue&type=style&index=0&id=449ea19e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "449ea19e",
  null
  
)

export default component.exports